import styles from "./EnquiryModal.module.css";
import { EnquiryPersonalFormData } from "./EnquiryPersonalForm";
import { EnquiryTravelFormData } from "./EnquiryTravelForm";

interface EnquirySuccessViewProps {
  travelDetails: EnquiryTravelFormData | null;
  personalDetails: EnquiryPersonalFormData | null;
}

function formatDate(dateString: string) {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "2-digit",
  });
}

function EnquirySuccessView(props: EnquirySuccessViewProps) {
  const { travelDetails, personalDetails } = props;

  return (
    <div className={styles.summaryHeader}>
      {/* Blue banner at the top */}
      <div className={styles.successBanner}>
        <h3>{travelDetails?.destination || "Any destination"}</h3>
        <p>
          {travelDetails?.nights || "1"} night
          {travelDetails?.nights !== "1" ? "s" : ""},{" "}
          {travelDetails?.rounds || "1"} round
          {travelDetails?.rounds !== "1" ? "s" : ""} on{" "}
          {formatDate(travelDetails?.arrival_date || "Fri 23 May 25")}
        </p>
      </div>

      <div className={styles.successContent}>
        <div className={styles.checkmarkContainer}>
          <div className={styles.checkmark}>✓</div>
        </div>

        <div className={styles.successMessageContent}>
          <h2 className={styles.successTitle}>
            Thank you, {personalDetails?.first_name?.split(" ")[0]}
          </h2>

          <p>
            We've received your enquiry, thanks! You are now just moments away
            from a great golf holiday.
          </p>

          <p>
            The next step is one of our Golf Travel Experts (who will have
            played the golf courses) will be in touch to organise the perfect
            trip for you.
          </p>

          <p>
            If your enquiry is urgent, we recommend you call{" "}
            <a href="tel:08000436644" className={styles.phoneLink}>
              0800 043 6644
            </a>{" "}
            where our Golf Travel Experts can help you within 60 seconds.
          </p>
        </div>
      </div>
    </div>
  );
}

export default EnquirySuccessView;
export { EnquirySuccessView, type EnquirySuccessViewProps };
